import React, { Component } from 'react';
import Chip from 'material-ui/Chip';
import CollectorButtons from './CollectorButtons'
import {
	Datagrid,
	List,
	Responsive,
	// SimpleList,
	TextField,
	Edit,
	TabbedForm,
	FormTab,
	DateInput,
	DateField,
	NumberField,
	LongTextInput,
} from 'admin-on-rest';
import {
	FunctionField,
	ReferenceField,
} from 'admin-on-rest/lib/mui';
import { formatDate, stringHumanize, formatPeso, dateString } from '../util'
import AccountListActions from '../AccountListActions'
import customerName from './customerName'
import hasDocDef from './hasDocDef'
import SubmitORCR from './SubmitORCR'
import jQuery from 'jquery';
import DocDefEditTab from './DocDefEditTab'
import EditActions from './EditActions'
import AccountFilters from './AccountFilters'
import NoteButton from './NoteButton'
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import { Link } from 'react-router-dom';
import SimpleList from '../SimpleList'
import AccountLinkField from '../DCAccount/AccountLinkField'

const netProceeds = ({ fields }) => {
	if ( ! fields.proceeds && ! fields.chattel_mortgage_fee ) {
		return '–'
	}
	const collected = parseFloat( fields.proceeds.replace( /,/g, '' ) )
	if ( ! fields.chattel_mortgage_fee ) {
		return formatPeso( collected )
	}
	const chattel = parseFloat( fields.chattel_mortgage_fee.replace( /,/g, '' ) )
	return formatPeso(collected - chattel)
}

const proceedsCollected = ({ fields }) => {
	if ( ! fields.proceeds_collected ) {
		return '–'
	}
	return formatPeso(parseFloat( fields.proceeds_collected.replace( /,/g, '' ) ))
}

const diAmount = ({ fields }) => {
	if ( ! fields.proceeds || ! fields.di ) {
		return '–'
	}
	const proceeds = parseFloat( fields.proceeds.replace( /,/g, '' ) )
	const di = parseFloat( fields.di.replace( /,/g, '' ) ) / 100
	return formatPeso(proceeds * di)
}

const diCollected = ({ fields }) => {
	if ( ! fields.di_collected ) {
		return '–'
	}
	return formatPeso(parseFloat( fields.di_collected.replace( /,/g, '' ) ))
}

export const CollectorAccountList = (props) => (
    <List {...props}
		filters={<AccountFilters />}
		actions={<AccountListActions refreshInterval="900000" />}
		perPage={25}
		>
		<Responsive
            small={
                <SimpleList
                    primaryText={record => (
						// TODO missing doc def status indicator & button
						// TODO missing OR/CR button
						// TOOD missing bank (ReferenceField doesn't work) and bank contact person
						<div>
							<Link to={`accounts/${record.id}`} style={{ lineHeight: '1.6em', textDecoration: 'none', color: darkBlack }}>
								<div>
									<span style={{ fontWeight: 'bold' }}>#{record.fields.cs_num}</span>
									<Chip style={{ float: 'right' }}>{stringHumanize(record.fields.status)}</Chip>
								</div>
								<p>
									{customerName(record)}<br/>
									{stringHumanize(record.fields.dealership)}
								</p>
								<p style={{ color: lightBlack }}>
									Net Proceeds <span style={{ float: 'right' }}>{netProceeds(record)}</span><br/>
									Proceeds Collected <span style={{ float: 'right' }}>{proceedsCollected(record)}</span><br/>
									Di Amount <span style={{ float: 'right' }}>{diAmount(record)}</span><br/>
									Di Collected <span style={{ float: 'right' }}>{diCollected(record)}</span>
								</p>
							</Link>
							<CollectorButtons label="Actions" record={record} options={{ fullWidth: true, style: { margin: 0 } }} />
						</div>
					)}
                />
            }
            large={
				<Datagrid>
		            <AccountLinkField source="fields.cs_num" label="CS #" sortable={false} />
					<FunctionField label="Customer" render={customerName} />
					<FunctionField label="Dealership" render={ ({fields}) => stringHumanize(fields.dealership) } />
					<DateField source="fields.transmitted_date" label="Transmitted Date" sortable={false} />
					<NumberField source="fields.age" label="Age" sortable={false} />
					<ReferenceField label="Bank" source="fields.bank" reference="banks" allowEmpty validation={{ required: true }} linkType={false} sortable={false}>
						<TextField source="name"/>
					</ReferenceField>
					<TextField source="fields.bank_contact_person" label="Bank AO" sortable={false} />
					<TextField source="fields.bank_contact_number" label="Bank Number" sortable={false} />
					<FunctionField label="Net Proceeds" render={netProceeds} />
					<FunctionField label="Proceeds Collected" render={proceedsCollected} />
					<FunctionField label="DI Amount" render={diAmount} />
					<FunctionField label="DI Collected" render={diCollected} />
					<FunctionField label="Status" render={ ({fields}) => <Chip>{stringHumanize(fields.status)}</Chip> } />
					<FunctionField label="Doc Def" render={hasDocDef} />
					<CollectorButtons label="Actions" />
					<SubmitORCR label="OR/CR" />
					<NoteButton label="Notes" />
		        </Datagrid>
            }
        />
    </List>
)

const AccountTitle = ({ record }) => (
	<span>
		Account
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		ID {record.id}
		<span style={{ color: '#999' }}>&nbsp; &middot; &nbsp;</span>
		CS# {record.fields.cs_num}
	</span>
)

export class CollectorAccountEdit extends Component {
	getURLParam(name) {
	    return (this.props.location.search.split(name + '=')[1] || '').split('&')[0];
	}

	componentWillRender() {
		this.movedTabs = false;
	}

	render() {
		let tab = this.getURLParam('tab')
		if ( tab && ! this.movedTabs ) {
			setTimeout( function() {
				if ( ! this.movedTabs ) {
					let tabFound = jQuery( `.tabbed-form .form-tab:eq(${tab})` );
					if ( tabFound.length ) {
						tabFound.click();
						this.movedTabs = true;
					}
				}
			}.bind( this ), 10 );
		}

		return (
			<Edit title={<AccountTitle />} {...this.props} actions={<EditActions/>}>
				<TabbedForm value="1" submitOnEnter={false}>
					<FormTab label="Details">
						<ReferenceField label="Dealership" source="fields.dealership" reference="dealerships" allowEmpty validation={{ required: true }} linkType={false}>
							<TextField source="name"/>
						</ReferenceField>
						<TextField label="First Name" source="fields.first_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Last Name" source="fields.last_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Middle Name" source="fields.middle_name" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Company Name" source="fields.company_name" />
						<TextField label="Sales Consultant" source="fields.sales_consultant" />
						<DateInput label="OR/CR Submission Date" source="fields.or__cr_submission_date" parse={dateString}/>
						<TextField label="Model" source="fields.model" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Engine Number" source="fields.engine_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Chasis / Frame Number" source="fields.chasis_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
					</FormTab>
					<FormTab label="Payment">
						<ReferenceField label="Bank" source="fields.bank" reference="banks" allowEmpty validation={{ required: true }} style={{ display: 'inline-block' }} linkType={false}>
							<TextField source="name"/>
						</ReferenceField>
						<ReferenceField label="Payment Mode" source="fields.payment_mode" reference="bank_payment_modes" allowEmpty validation={{ required: true }} style={{ display: 'inline-block', marginLeft: 32 }} linkType={false}>
							<TextField source="name"/>
						</ReferenceField>
						<br style={{ height: 0 }}/>
						<TextField label="Invoice Date" source="fields.invoice_date" options={{ formatDate }} style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Invoice Number" source="fields.invoice_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Invoice Amount (₱)" source="fields.invoice_amount" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Financing Rate (%)" source="fields.financing_rate" />
						<TextField label="Term" source="fields.term" />
						<TextField label="Proceeds Amount (₱)" source="fields.proceeds" />
						<TextField label="Proceeds Collected (₱)" source="fields.proceeds_collected" />
						<TextField label="DI Percentage (%)" source="fields.di" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="DI Amount (₱)" source="fields.di_amount" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Chattel Mortgage Fee (₱)" source="fields.chattel_mortgage_fee" />
						<TextField label="Bank Contact Person" source="fields.bank_contact_person" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
						<TextField label="Bank Contact Number" source="fields.bank_contact_number" style={{ display: 'inline-block', marginRight: 32, minWidth: 250 }} />
					</FormTab>
					<FormTab label="Doc Defs">
						<DocDefEditTab />
					</FormTab>
					<FormTab label="Notes & Remarks">
						<LongTextInput label="Collector Notes" source="fields.collector_notes" />
						<LongTextInput label="Proceeds Collection Remarks" source="fields.proceeds_collection_notes" />
						<LongTextInput label="DI Collection Remarks" source="fields.di_collection_notes" />
					</FormTab>
				</TabbedForm>
		    </Edit>
		)
	}
}

// Cannot use this now, wait for this to be fixed: https://github.com/marmelab/aor-dependent-input/issues/18
// <DependentInput dependsOn="name" value="other">
// 	<TextInput label="Other" source="document_other_name"/>
// </DependentInput>



// WEBPACK FOOTER //
// ./src/CollectorAccount/index.js